import { schema } from "normalizr";

export const delayedCampaign = new schema.Entity(
    "delayedCampaigns",
    {},
    { idAttribute: "campaignId" }
);
export const delayedCampaignList = new schema.Array(delayedCampaign);
